import { API_URL } from 'constants';

export const DEFAULT_INVENTORY_TYPE_URL = `${API_URL}/api/v1/inventorytype`;
